import { Platform } from 'react-native';

export const title = (text: string) => Platform.select({ web: `Evoluno | ${text}`, default: text });
